export default __webpack_public_path__ + "static/media/users.fce5ae2d.svg";